import React from 'react'
import { bool, func, string } from 'prop-types'

import { Modal, ModalBody } from 'components/qstrap'

import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'

const MoreInfoModal = ({
  isOpen,
  onModalClose,
  text,
}) => (
  <Modal
    autoFocus={false}
    isOpen={isOpen}
    fade={false}
    toggle={onModalClose}
    className="more-info-modal__dialog"
  >
    <ModalBody>
      <Typography variant="subbody" component="div" className="more-info-modal__text">
        {text}
      </Typography>

      <Button tag="a" onClick={onModalClose} variant="default" className="more-info-modal__btn">
        Mengerti
      </Button>
    </ModalBody>
    <style jsx global>
      {`
        .more-info-modal {
          &__dialog {
            margin: 300px 24px;
            max-width: 972px;
            .modal-content {
              height: 100%;
              border: none !important;
              box-shadow: none !important;
              padding: 24px;
              display: flex;
            }
            .modal-body {
              padding: 0;
            }
          }
          :global(&__text) {
            color: #1a344f !important;
          }
          &__wrapper {
            padding-bottom: 56.25%; /* 16:9 */
            position: relative;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
          }
          &__btn {
            font-weight: bold;
            width: 100%;
            padding: 12px;
            float: right;
            margin-top: 24px;
          }
        }
        .modal-backdrop {
          opacity: 0.8;
          background-color: #1a344f;
        }
      `}
    </style>
  </Modal>
)

MoreInfoModal.propTypes = {
  isOpen: bool,
  onModalClose: func,
  text: string,
}

export default MoreInfoModal
